import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/Button';
import Paper from 'components/Paper';
import Input from 'components/Input';
import PasswordRules from 'components/PasswordRules';
import ResendWidget from 'components/ResendWidget';

const StyledResetPasswordView = styled.div`
  form {
    > * {
      margin-bottom: ${({ theme }) => theme.spacing * 4}px;
    }
  }

  ${Paper} {
  margin-bottom: ${({ theme }) => theme.spacing * 4}px;
  }
`;

const ResetPasswordView = (
  {
    email, minPasswordLength, className, error, onSubmit, onChange, onResendClick,
  },
) => {
  const classes = ['ResetPasswordView'];
  const [value, setValue] = useState({
    code: '',
    password: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(value.code, value.password);
  };

  const handleChange = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
    if (onChange) onChange(e.target.name, e.target.value);
  };

  if (className) classes.push(className);

  return (
    <StyledResetPasswordView className={classes.join(' ')}>
      <h1>Create a new password</h1>
      <p>
        We&apos;ve sent a password reset code by email to&nbsp;
        <strong>
          {email}
        </strong>
        . Enter it below to reset your password
      </p>
      <Paper>
        <form onSubmit={handleSubmit} noValidate>
          <Input
            label="Code"
            name="code"
            type="text"
            placeholder="Enter the email code"
            value={value.code}
            error={error && error.code}
            onChange={handleChange}
            focus
          />
          <Input
            label="Password"
            name="password"
            type="password"
            placeholder="Enter a new password"
            value={value.password}
            error={error.password}
            onChange={handleChange}
          />
          <PasswordRules />
          <Button
            type="submit"
            disabled={!value.password
            || value.password.length < minPasswordLength
            || !value.code
            || error.code
            || error.password}
            fullWidth
          >
            Change password
          </Button>
        </form>
      </Paper>
      <ResendWidget
        onResendClick={onResendClick}
      />
    </StyledResetPasswordView>
  );
};

ResetPasswordView.displayName = 'ResetPasswordView';

ResetPasswordView.propTypes = {
  email: PropTypes.string.isRequired,
  minPasswordLength: PropTypes.number.isRequired,
  className: PropTypes.string,
  error: PropTypes.shape({
    code: PropTypes.string,
    password: PropTypes.string,
  }),
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onResendClick: PropTypes.func,
};

ResetPasswordView.defaultProps = {
  className: null,
  error: null,
  onChange: null,
  onResendClick: null,
};

export default ResetPasswordView;
